











































































import { defineComponent, ref, PropType, computed } from '@vue/composition-api';
import { DotsVerticalIcon } from '@vue-hero-icons/outline';
import { OnClickOutside } from '@/app/components';
import { isNil, has } from 'ramda';
import CopyToClipboardButton from '@/app/components/CopyToClipboardButton.vue';

export default defineComponent({
    name: 'CardLayoutCard',
    components: { DotsVerticalIcon, OnClickOutside, CopyToClipboardButton },
    props: {
        status: { type: String, required: false },
        statusMap: {
            type: Object as PropType<Record<string, { label: string; background: string; text: string }>>,
        },
        tags: { type: Array as PropType<string[]>, default: () => [] },
        actions: {
            type: Array as PropType<
                {
                    id: string;
                    label: string;
                    icon: any;
                    click?: any;
                    to?: any;
                    tooltip?: string;
                    component?: any;
                    props?: any;
                }[]
            >,
            default: () => [],
        },
    },
    setup(props) {
        const open = ref<boolean>(false);

        const statusLabel = computed(() => {
            if (isNil(props.status) || !has(props.status, props.statusMap)) return undefined;

            return props.statusMap[props.status].label;
        });

        const statusBgColour = computed(() => {
            if (isNil(props.status) || !has(props.status, props.statusMap)) return `bg-neutral-200`;

            return props.statusMap[props.status].background;
        });

        const statusTxtColour = computed(() => {
            if (isNil(props.status) || !has(props.status, props.statusMap)) return `text-neutral-700`;

            return props.statusMap[props.status].text;
        });

        return { open, statusLabel, statusBgColour, statusTxtColour };
    },
});
